/*
 * Copyright (c) 2019-2022 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import { SessionParams } from '../context/SessionContext';
import {
  isInstantJoinTechnicallySupported,
  isMobileJoinTechnicallySupported,
  isNativeEndpointTechnicallySupported,
} from './ProductCompatibilityService';
import { navigateTo } from './NavigatorService';
import { buildWebAppJoinUrl } from './UrlService';
import { sendJoinLaunchEvent } from '../lib/telemetry';
import { getUserType, UserType } from '../lib/userType';
import { FlowType, Product } from './IndexPageReaderService';

export const redirectIfWebFirst = (params: SessionParams): boolean => {
  const {
    meetingId,
    meetingInfo,
    sessionTrackingId,
    theme,
    isDesktopEnforced,
  } = params;

  const userType = getUserType();

  const isWebFirstNotSuitable =
    (!params.meetingInfo.sessionOptions.webViewerDefault &&
      isNativeEndpointTechnicallySupported) ||
    isDesktopEnforced ||
    params.flowType === FlowType.Install ||
    isMobileJoinTechnicallySupported ||
    params.product !== Product.G2M ||
    userType === UserType.Frequent;

  if (isWebFirstNotSuitable) {
    return false;
  }

  if (isInstantJoinTechnicallySupported) {
    sendJoinLaunchEvent(
      params.telemetryService,
      meetingId,
      sessionTrackingId,
      userType,
      'auto_web_join',
      meetingInfo.build,
      theme.themeType,
      0
    );
    navigateTo(buildWebAppJoinUrl(meetingId, sessionTrackingId));
    return true;
  }
  return false;
};
